/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */

/**
 * * `INCLUDED` - Includes tips
 * * `NOT_INCLUDED` - No tips
 * * `POOLED` - Pooled tips
 */
export type TipPolicyEnum = typeof TipPolicyEnum[keyof typeof TipPolicyEnum];


export const TipPolicyEnum = {
  INCLUDED: 'INCLUDED',
  NOT_INCLUDED: 'NOT_INCLUDED',
  POOLED: 'POOLED',
} as const;
